import React from "react";
import Header from "../Header/Header";
import { Button } from "react-bootstrap";
import "firebase/auth";
import firebaseConfig from "./firebase.config";
import firebase from "firebase/app";
import { useState } from "react";
import { useContext } from "react";
import { UserContext } from "../../App";
import { useHistory, useLocation } from "react-router-dom";




if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.app(); // if already initialized, use that one
  }



const Login = () => {





const [user,setUser] = useState();


const [ signInUser, setSignInUser] = useContext(UserContext);
const history = useHistory();
const location = useLocation();

let { from } = location.state || { from: { pathname: "/" } };

const googleProvider = new firebase.auth.GoogleAuthProvider();


const handleSignIn = () => {

    firebase.auth().signInWithPopup(googleProvider)
    .then(res => {

        const {displayName,photoURL,email} = res.user;
        const newUser={
            userName:displayName,
            email:email,
            userPhoto:photoURL
        }

        setSignInUser(newUser)
        history.replace(from);
        console.log(res)
    })
    .catch(err => {


        console.log(err.message)
    })


 

}



  return (
    <div className="container">
    <Header></Header>
      <div style={{textAlign: 'center'}}>
      <h3>Login Now</h3>
      <Button  onClick={handleSignIn}   variant="primary">Continue With Google</Button>

      </div>
    </div>
  );
};

export default Login;
